import styled from '@emotion/styled'

import type { FC } from 'react'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroUseCaseBase, * as HeroUseCase from '@segment/matcha/recipes/Hero'

const copy = {
  overline: `Use Cases`,
  heading: `Empower every team <br>with good data`,
}

const Hero: FC = () => {
  return (
    <Wrapper>
      <StyledHeroUseCaseBase variant="centered" copyVariant="wide">
        <HeroUseCase.Copy>
          <CopyTextBase centered={true}>
            {/*
             * I have no idea why this is happening but:
             * Using typography with font-size: 16px on the `CopyText.Overline`,
             * breaks the infinite scrolling at the bottom of the page.
             */}
            <CopyText.Overline variant="h5">{copy.overline}</CopyText.Overline>
            <CopyText.Heading
              tag="h1"
              variant="h1"
              dangerouslySetInnerHTML={{ __html: copy.heading }}
            ></CopyText.Heading>
          </CopyTextBase>
        </HeroUseCase.Copy>
      </StyledHeroUseCaseBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background: ${({ theme }) => theme.palette.twilio.green[10]};
`

const StyledHeroUseCaseBase = styled(HeroUseCaseBase)`
  ${HeroUseCase.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding-top: 80px;
      padding-bottom: 80px;
    }
  }
`

export default Hero
